import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import { withRouter } from 'react-router-dom'

import Stars from '../../../Common/Stars';
import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon, UserRoleIcon } from '../../../Common/Buttons/TypeIcons';

import { setProfileDb } from "../../../../Actions/dataActions";
import { UserProfile, TagProfile, ServiceProfile } from '../../../Common/Buttons/Icons';
import { Trans } from 'react-i18next';
import { formatPhone } from '../../../../Helpers/PhoneHelper';

//Pass a profile prop with the necessary details
class ProfileCell extends Component {
    constructor(props) {
        super(props);

        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.showOverlay = this.showOverlay.bind(this);
        this.onClickAction = this.onClickAction.bind(this);

        this.generateImage = this.generateImage.bind(this);

        this.state = {
            show_tooltip: false
        };
    }

    componentDidMount() {
        if (this.props.profile) {
            if ("profile" in this.props && this.props.profile !== null && !(this.props.profile.ID in this.props.data.profile_db) && (!("status" in this.props.profile) || this.props.profile.status !== "Invited")) {
                this.props.dispatch(setProfileDb([this.props.profile], this.props.data.profile_db))
            }
        }
    }
    
    showTooltip() {
        if (this.props.showTooltip !== false && (! (this.props.profile && "Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service)) && ! (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service)) {
            this.setState({
                show_tooltip: true
            })
        }
    }

    hideTooltip() {
        this.setState({
            show_tooltip: false
        })
    }

    onClickAction(e) {
        if("onclick" in this.props) {
            this.props.onclick();
        } else {
            this.showOverlay();
        }
    }

    showOverlay() {
        if (! this.props.noOverlay && this.props.profile && this.props.profile.status !== "Invited" && (! ("Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service)) && ! (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service)) {
            var base_url = (this.props.match.url).split('/')[1]
            this.props.history.push("/" + base_url + '/profile/' + this.props.profile.ID + '/Overview')
        }
    }

    generateImage() {
        //Service Image
        if ((this.props.profile && "Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service) || (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service)) {
            return (
                <div className = "user-prof-img float-left">
                    <div style={{margin: "5px"}}>{ServiceProfile()}</div>
                </div>
            )
        //Internal Tag
        } else if (this.props.profile && this.props.profile.Is_User === 0) {
            return(                    
                <div className = "user-prof-img float-left">
                    <div style={{margin: "5px"}}>{TagProfile()}</div>
                </div>
                )
        //Real User
        } else if (this.props.profile && this.props.profile.Is_User === 1) {
            if ("photo" in this.props.profile && this.props.profile.photo && "Link" in this.props.profile.photo && this.props.profile.photo.Link !== "") {
                // return(<img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/user-images/thumbnails/thumbnail_' + this.props.profile.Photos} className="circled_image"/>)
                return(
                    <div className = "user-prof-img float-left">
                         <img style={{margin: "5px", borderRadius: "50%"}} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.profile.photo.Link}/>
                        {'sh_vmh_access' in this.props.profile && this.props.profile.sh_vmh_access.length > 0 ? 
                            <span className = "userrole-img" style={{bottom: "-6px", right: "-8px"}}>{UserRoleIcon(this.props.profile.sh_vmh_access[0].User_Role)}</span> 
                        : null }
                    </div>
                )
            } else {
                return(
                    <div className = "user-prof-img float-left">
                        <div style={{margin: "5px"}}>{UserProfile()}</div>
                        {'sh_vmh_access' in this.props.profile && this.props.profile.sh_vmh_access.length > 0 ? <span className = "userrole-img">{UserRoleIcon(this.props.profile.sh_vmh_access[0].User_Role)}</span>  : null }
                    </div>
                )
            }
        } else if (this.props.profile && this.props.profile.status === "Invited") {
            if ('sh_requests' in this.props.profile && this.props.profile.sh_requests.length > 0) {
                if ("photo" in this.props.profile && this.props.profile.photo && "Link" in this.props.profile.photo && this.props.profile.photo.Link !== "") {
                    // return(<img src={'https://digitalvms.s3.ca-central-1.amazonaws.com/user-images/thumbnails/thumbnail_' + this.props.profile.Photos} className="circled_image"/>)
                    return(
                        <div className = "user-prof-img float-left">
                             <img style={{margin: "5px", borderRadius: "50%"}} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.profile.photo.Link}/>
                             {'sh_vmh_access' in this.props.profile && this.props.profile.sh_vmh_access.length > 0 ? <span className = "userrole-img" style={{bottom: "-6px", right: "-8px"}}>{UserRoleIcon(this.props.profile.sh_requests[0].User_Role_ID)}</span> : null}
                        </div>
                    )
                } else {
                    return(
                        <div className = "user-prof-img float-left">
                            (<div style={{margin: "5px"}}>{UserProfile()}</div>
                            {'sh_vmh_access' in this.props.profile && this.props.profile.sh_vmh_access.length > 0 ? <span className = "userrole-img">{UserRoleIcon(this.props.profile.sh_requests[0].User_Role_ID)}</span> : null}
                        </div>
                    )
                }
            } else {
                if ("photo" in this.props.profile && this.props.profile.photo && "Link" in this.props.profile.photo && this.props.profile.photo.Link !== "") {
                    return(
                        <div className = "user-prof-img float-left">
                             <img style={{margin: "5px", borderRadius: "50%"}} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/profile-images/thumbnails/thumbnail_' + this.props.profile.photo.Link}/>
                        </div>
                    )
                } else {
                    return(
                        <div className = "user-prof-img float-left">
                            <div style={{margin: "5px"}}>{UserProfile()}</div>
                        </div>
                    )
                }
            }

        }
    }

    render(props) {
        return (
            <>
                {this.props.profile ? 
                <div className="vehicle_cell_container" onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip} onClick={this.onClickAction}>
                    <div className="vehicle_cell">
                        {
                            this.props.showImage ?
                                <div className="user_cell_thumbnail">
                                    {this.generateImage()}
                                </div>
                            :
                                null
                        }
                        <div className = "user-prof-name float-left">
                            {
                                (this.props.profile && "Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service) || (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service) ?
                                    <span><Trans>Service Booking</Trans></span>
                                :
                                    this.props.profile.First_Name && this.props.profile.First_Name !== '' ? 
                                        <span style={{maxWidth:'180px'}}>{this.props.profile.First_Name} {this.props.profile.Last_Name}</span>
                                    :
                                        <span style={{maxWidth:'180px'}}>{this.props.profile.Email}</span>
                            }
                            <br />
                            {
                                (this.props.profile && "Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service) || (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service) ?
                                    null
                                :
                                    this.props.profile && this.props.profile.status === "Invited" ?
                                        <div className="caption "><Trans>Invited User</Trans></div>
                                    :
                                        this.props.profile && this.props.profile.Title !== "" && this.props.profile.Title !== null ?
                                            this.props.profile.Company !== "" && this.props.profile.Company !== null ? 
                                                <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}>{this.props.profile.Title} at {this.props.profile.Company}</div>
                                            :
                                                <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}>{this.props.profile.Title}</div>
                                        :
                                            this.props.profile && this.props.profile.Company !== "" && this.props.profile.Company !== null ? 
                                                <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}>{this.props.profile.Company}</div>
                                            :
                                                <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}></div>
                                }
                                {this.props.showContact ? 
                                <div>
                                    <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}>{this.props.profile.Email}</div>
                                    {
                                        this.props.profile.phonenumbers && this.props.profile.phonenumbers.length > 0 ?
                                            <div className="caption truncate" style = {{fontSize:"12px",maxWidth:'180px'}}>{formatPhone(this.props.profile.phonenumbers[0].Number)}</div>
                                        :
                                            null
                                    }
                                </div> : null
                                }          
                        </div>
                        {
                            this.props.showType && this.props.profile && "sh_vmh_access" in this.props.profile && this.props.profile.sh_vmh_access.length > 0 ? 
                                <div className="vehicle_cell_type">
                                    {VCIcon(this.props.profile.sh_vmh_access[0].vmh, undefined, undefined, undefined, true)}
                                    {DivisionIcon(this.props.profile.sh_vmh_access[0].stakeholder, undefined, undefined, undefined, true)}
                                </div>
                            :
                                null
                        }
                    </div>

                    {
                        ! this.props.noTooltip && this.state.show_tooltip && (! (this.props.profile && "Book_Type" in this.props.profile && this.props.profile.Book_Type === constants.booking_type.service ) && ! (this.props.booking && "Book_Type" in this.props.booking && this.props.booking.Book_Type === constants.booking_type.service)) ?
                            <div className="vehicle_cell_tooltip_container">
                                <div className="vehicle_cell_tooltip">
                                    <div className="vehicle_cell_tooltip_info">
                                        <div className="user_tooltip_thumbnail">
                                            {this.generateImage()}
                                        </div>
                                        <div className="vehicle_cell_tooltip_info_info_title_area">
                                            <div className="vehicle_cell_tooltip_info_info_title">
                                                <span className="vehicle_cell_tooltip_info_title_text">{this.props.profile.First_Name} {this.props.profile.Last_Name}</span>
                                                {
                                                    (!("status" in this.props.profile) || this.props.profile.status !== "Invited") && this.props.profile.ID in this.props.data.profile_db && "tier" in this.props.data.profile_db[this.props.profile.ID] && this.props.data.profile_db[this.props.profile.ID].sh_vmh_access && this.props.data.profile_db[this.props.profile.ID].sh_vmh_access.length > 0 && this.props.data.profile_db[this.props.profile.ID].sh_vmh_access[0].tier !== null ?
                                                        <Stars star={this.props.data.profile_db[this.props.profile.ID].sh_vmh_access[0].tier.Rank} type={"Profile"}/> 
                                                    :
                                                        "status" in this.props.profile && this.props.profile.status === "Invited" && this.props.profile.tier ?
                                                            <Stars star={this.props.profile.tier.Rank} type={"Profile"} />
                                                        :
                                                            null
                                                }
                                            </div>
                                            <div className="vehicle_cell_tooltip_info_subtitle">
                                                {
                                                    this.props.profile && this.props.profile.status === "Invited" ?
                                                        <span>Invited User</span>
                                                    :
                                                        this.props.profile && this.props.profile.Title !== "" && this.props.profile.Title !== null ?
                                                            this.props.profile.Company !== "" && this.props.profile.Company !== null ? 
                                                                <span className="vehicle_cell_tooltip_vin" style = {{borderRight:0}}>{this.props.profile.Title} at {this.props.profile.Company}</span>
                                                            :
                                                                <span className="vehicle_cell_tooltip_vin" style = {{borderRight:0}}>{this.props.profile.Title}</span>
                                                        :
                                                            this.props.profile && this.props.profile.Company !== "" && this.props.profile.Company !== null ? 
                                                                <span className="vehicle_cell_tooltip_vin" style = {{borderRight:0}}>{this.props.profile.Company}</span>
                                                            :
                                                                <span className="vehicle_cell_tooltip_vin" style = {{borderRight:0}}></span>
                                                }
                                                
                                            </div>
                                        </div>

                                    </div>
                                    {
                                        this.props.profile && "sh_vmh_access" in this.props.profile && this.props.profile.sh_vmh_access.length > 0 && this.props.profile.sh_vmh_access.vmh && this.props.profile.sh_vmh_access.stakeholder ?
                                            <div className="vehicle_cell_tooltip_type">
                                                <span className="vehicle_cell_tooltip_type_icon">{VCIcon(this.props.profile.sh_vmh_access[0].vmh, undefined, undefined, undefined, true)}{this.props.profile.sh_vmh_access[0].vmh.Display_Name + " - " + this.props.profile.sh_vmh_access[0].vmh.Display_City}</span>
                                                <span className="vehicle_cell_tooltip_type_icon" style={{marginTop: 6}}>{DivisionIcon(this.props.profile.sh_vmh_access[0].stakeholder, undefined, undefined, undefined, true)}{this.props.profile.sh_vmh_access[0].stakeholder.Division} Division</span>
                                            </div>
                                        :
                                            null
                                    }

                                </div>
                            </div>
                        :
                            null
                    }
                </div> : null}
            </>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(ProfileCell)